export default __webpack_public_path__ + "static/media/UI_TabBar_bottom.e2676232.jpg";